module.exports = __webpack_public_path__ + "static/media/logo-cci.bca3d5de.svg";